// extracted by mini-css-extract-plugin
export default {"wrapper":"aO001Z"};